import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import ChevronNewIcon from '@/component-library/primitives/Icons/ChevronNewIcon/ChevronNewIcon';

import { CustomCard } from '../DashboardPage/Components/MetricComponents';

interface SettingsCardParams {
  label: string;
  description: string;
  icon?: React.ReactElement;
  route?: string;
  disabled?: boolean;
}

const SettingsCard = (params: SettingsCardParams) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="cursor-pointer" onClick={() => navigate(params.route!)}>
      <CustomCard className="h-full transition-colors hover:border-custom-blue/50">
        <div className="flex flex-row items-center gap-4 h-full">
          {params.icon && params.icon}
          <div className="flex flex-col w-[80%]">
            <h2 className="text-custom-black text-base mb-1">{t(params.label)}</h2>
            <p className="text-custom-darkSilver text-sm">{t(params.description)}</p>
          </div>
          <ChevronNewIcon type="right" width="40" height="40" />
        </div>
      </CustomCard>
    </div>
  );
};

export default SettingsCard;
